module.exports = __webpack_public_path__ + "static/niall-327ec162a11788c9a5ab3a6cb1136294.jpg";